import React, { useEffect, useState, useRef } from "react";
import { Formik, Field } from "formik";
import * as Yup from "yup";
import formimg from "../Forms/Performance-Appraisal-Templates-1-1013x439 1.svg";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useSearchParams } from "react-router-dom";
import axios from "axios";
import { Toast, ToastContainer } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { baseURL } from "../../config";

function SubCategoryForm() {
  const [showModal, setShowModal] = useState(false);
  const [formData, setFormData] = useState(null);
  const [catname, setCatgoryName] = useState(null);
  const [searchParams] = useSearchParams();
  const [showToast, setShowToast] = useState(false);
  const [categories, setCategories] = useState([]);

  const navigate = useNavigate();
  const usernameRef = useRef(null);

  let id = searchParams.get("id");

  console.log(searchParams.get("id")); // 'name'

  const handleSubmit = async (values) => {
    setFormData(values); // Store form data before displaying the modal
    setShowModal(true); // Show the confirmation modal
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  useEffect(() => {
    const getCategories = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getcategories`,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        if (response.statusText === "OK") {
          setCategories(response.data.categories);
          // window.location.href = "/createTemplateTab";
        } else {
          console.error("get category details   failed:", response.statusText);
        }
      } catch (error) {
        console.error("get category details   An error occurred:", error);
      }
    };
    getCategories();
  }, []);
  useEffect(() => {
    const findCategoryName = async () => {
      try {
        const response = await axios.get(
          `${baseURL}/getCcategorydetails/` + id,
          {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
          }
        );

        if (response.statusText === "OK") {
          let catname = response.data.category.categoryname;
          setCatgoryName(catname);
          // window.location.href = "/createTemplateTab";
        } else {
          console.error("get category details   failed:", response.statusText);
        }
      } catch (error) {
        console.error("get category details   An error occurred:", error);
      }
    };
    findCategoryName();
  }, []);

  const handleConfirmSubmit = async () => {
    //formval= formval.replace(/\\"/g, '"')
    let parentcategoryid = formData.parentcategoryid;
    let subcategoryname = formData.subcategoryname;

    const resp = await axios.get(
      `${baseURL}/addsubcategory?parentcategoryid=` +
        parentcategoryid +
        "&subcategoryname=" +
        subcategoryname,
      {
        method: "get",
      }
    );

    if (resp.status) {
      setFormData(null);
      setShowModal(false);
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
        navigate("/subcategorytable");
      }, 3000);

      // window.location.href = "/subcategorytable";
    } else {
      console.error("Form submission failed:", resp.statusText);
    }
  };

  return (
    <>
      <Formik
        initialValues={{
          subcategoryname: "",
          parentcategoryid: id,
          subcategorynametwo: "",
        }}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit,
        }) => (
          <div className="container">
            <h4 className="text-start  pb-2">Create Sub Category</h4>
            <div className="col-lg-12  mt-1 m-5 mt-4 pt-3">
              <form noValidate onSubmit={handleSubmit}>
                <div className="row">
                  <div className="col-lg-5">
                    <label className="formlabel">
                      {" "}
                      Primary Category <span className="text-danger">*</span>
                    </label>
                    <input
                      type="hidden"
                      className={`form-control ${
                        touched.parentcategoryid && errors.parentcategoryid
                          ? "is-invalid"
                          : ""
                      }bg-secondary text-white `}
                      placeholder="Enter title"
                      name="parentcategoryid2"
                      value={id}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    <span className="p-2 pt-4">:</span>
                    <Field
                      as="select"
                      onChange={handleChange}
                      value={id}
                      disabled={id === null ? false : true}
                      name="parentcategoryid"
                      className="category-select w-100 p-2"
                    >
                      <option value="">Select Category</option>
                      {categories.map((category) => (
                        <option key={category.id} value={category.id}>
                          {category.categoryname}
                        </option>
                      ))}
                    </Field>
                  </div>

                  <div className="col-lg-5 ml-5">
                    <label className="formlabel">
                      {" "}
                      Sub Category<span className="text-danger">*</span>
                    </label>
                    <input
                      type="text"
                      className={`form-control ${
                        touched.subcategoryname && errors.subcategoryname
                          ? "is-invalid"
                          : ""
                      }`}
                      placeholder="Enter title"
                      name="subcategoryname"
                      value={values.subcategoryname}
                      onChange={handleChange}
                      onBlur={handleBlur}
                    />
                    {touched.subcategoryname && errors.subcategoryname ? (
                      <div className="text-danger">{errors.categoryname}</div>
                    ) : null}
                  </div>
                  {/* <button className="savebtn w-50">Create Another Sub Category +</button>   */}
                  <p>
                    {/* <a class="btn subcatbtn" data-bs-toggle="collapse" href="#collapseExample" role="button" aria-expanded="false" aria-controls="collapseExample">
              Add Another Subcategory +
          </a> */}
                  </p>
                  <div class="collapse" id="collapseExample">
                    <div class="card card-body">
                      <div className="col-lg-5">
                        <label className="formlabel">
                          {" "}
                          Sub Category<span className="text-danger">*</span>
                        </label>
                        <input
                          type="text"
                          className={`form-control ${
                            touched.subcategorynametwo &&
                            errors.subcategorynametwo
                              ? "is-invalid"
                              : ""
                          }`}
                          placeholder="Enter title"
                          name="subcategoryname"
                          value={values.subcategoryname}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {touched.subcategorynametwo &&
                        errors.subcategorynametwo ? (
                          <div className="text-danger">
                            {errors.subcategorynametwo}
                          </div>
                        ) : null}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="col-lg-11 text-end mt-4 pb-3">
                  <Button
                    className="border-0 mt-2 p-1 btn-#8d3523 savebtn"
                    type="submit"
                  >
                    Save
                  </Button>
                  <a
                    href="/createTemplateTab"
                    className="text-decoration-none "
                  >
                    {" "}
                    <Button
                      type="button"
                      className="btn cancelbtn ml-2"
                      onClick={() => setShowModal(false)}
                    >
                      Cancel
                    </Button>
                  </a>
                </div>
              </form>
            </div>
          </div>
        )}
      </Formik>

      {/* Confirmation Modal */}
      <div className="col-lg-12">
        <Modal show={showModal} onHide={handleCloseModal}>
          <Modal.Header closeButton>
            <Modal.Title>Confirmation</Modal.Title>
          </Modal.Header>
          <Modal.Body>Do You Want to Confirm the changes?</Modal.Body>
          <Modal.Footer>
            <Button variant="primary" onClick={handleConfirmSubmit}>
              Yes
            </Button>
            <Button variant="secondary" onClick={handleCloseModal}>
              No
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
      <div>
        <ToastContainer position="top-center" className="p-3">
          <Toast
            onClose={() => setShowToast(false)}
            show={showToast}
            delay={3000}
            autohide
            className="bg-success text-white"
          >
            <Toast.Header>
              <span className="me-2">✔️</span> {/* Unicode tick mark */}
              <strong className="me-auto">Notification</strong>
            </Toast.Header>
            <Toast.Body>Success!, data updated successfully!</Toast.Body>
          </Toast>
        </ToastContainer>
      </div>
    </>
  );
}

export default SubCategoryForm;
